import React from 'react'
import {getAuthHeader, getLocalStorageItem} from "../functions"
import config from "../config.json"

export class GoogleDriveViewFileClass extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: true,
            imageUrl: null,
            fileUrl: null,
            retryCount: 0,
            fullWidth: false,
            zoom: 1,
            offsetX: 0,
            offsetY: 0,
            isDragging: false,
            startX: 0,
            startY: 0,
        }
        this.maxRetries = 3
        this.imageRef = React.createRef()
        this.lastDist = null
    }

    componentDidMount() {
        const params = new URLSearchParams(window.location.search)
        const link = params.get('link')
        const mimeType = params.get('mime-type')
        if (!link) return

        if (mimeType.startsWith('video/')) {
            window.location.replace(link)
            return
        }

        const fileId = this.extractFileId(link)

        if (mimeType === 'application/pdf') {
            this.loadPdfAndDocs(fileId, 'application/pdf').then()
        } else {
            this.loadPdfAndDocs(fileId, 'application/docs').then()
        }

        window.addEventListener('wheel', this.handleWheelZoom, {passive: false})
    }

    componentWillUnmount() {
        const {fileUrl, imageUrl} = this.state
        if (fileUrl) URL.revokeObjectURL(fileUrl)
        if (imageUrl) URL.revokeObjectURL(imageUrl)
        window.removeEventListener('wheel', this.handleWheelZoom)
    }

    extractFileId(link) {
        const match = link.match(/[-\w]{25,}/)
        return match ? match[0] : ''
    }

    handleRetry = (fn, err) => {
        console.error(`Попытка ${this.state.retryCount + 1} не удалась`, err)
        if (this.state.retryCount < this.maxRetries - 1) {
            this.setState(
                prev => ({retryCount: prev.retryCount + 1}),
                () => setTimeout(fn, 1500)
            )
        } else this.handleError()
    }

    handleError = () => {
        const params = new URLSearchParams(window.location.search)
        const link = params.get('link')
        if (link) window.location.href = link
    }

    loadPdfAndDocs = async (fileId, mimeType) => {
        const auth = getLocalStorageItem('userData')
        const host = window.location.host === 'localhost:3000' ? config.localHost : config.onrender
        try {
            const response = await fetch(`${host}/api/google-drive/load-pdf-docs`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    Authorization: getAuthHeader(auth)
                },
                credentials: 'include',
                body: JSON.stringify({fileId, URI: window.location.origin, mimeType})
            })
            if (!response.ok) this.handleError()
            if (response['newAccessToken']) auth.accessToken = response['newAccessToken']
            const blob = await response.blob()
            const contentType = response.headers.get('Content-Type')
            if (!contentType.includes('pdf')) {
                // alert('⚠️ Получен не PDF, а: ' + contentType)
                this.handleError()
                return
            }
            const fileUrl = URL.createObjectURL(blob)
            this.setState({fileUrl, loading: false, retryCount: 0}, () => {
                setTimeout(() => this.toggleFullWidth(), 100)
            })
        } catch (err) {
            this.handleRetry(() => this.loadPdfAndDocs(fileId, mimeType), err)
        }
    }

    toggleFullWidth = () => {
        const navbar = document.querySelector('#navbar')
        const footer = document.querySelector('#footer')
        const body = document.body

        this.setState(
            prev => ({fullWidth: !prev.fullWidth, zoom: 1, offsetX: 0, offsetY: 0}),
            () => {
                if (this.state.fullWidth) {
                    navbar?.classList.add('d-none')
                    footer?.classList.add('d-none')
                    body.style.overflow = 'hidden'
                } else {
                    navbar?.classList.remove('d-none')
                    footer?.classList.remove('d-none')
                    body.style.overflow = ''
                }
            }
        )
    }

    handleWheelZoom = (e) => {
        if (!this.state.fullWidth || !this.imageRef.current) return
        e.preventDefault()
        const delta = e.deltaY < 0 ? 0.1 : -0.1
        this.setState(prev => ({zoom: Math.min(4, Math.max(0.5, prev.zoom + delta))}))
    }

    renderLoader() {
        return (
            <div style={{
                position: 'fixed', top: 0, left: 0,
                width: '100%', height: '100%',
                display: 'flex', alignItems: 'center', justifyContent: 'center',
                background: 'rgba(255,255,255,0.85)', zIndex: 9999
            }}>
                <div style={{
                    width: 60, height: 60,
                    border: '6px solid #ccc',
                    borderTop: '6px solid #0078ff',
                    borderRadius: '50%',
                    animation: 'spin 1s linear infinite'
                }}/>
                <style>{`
                    @keyframes spin {
                        0% { transform: rotate(0deg) }
                        100% { transform: rotate(360deg) }
                    }
                `}</style>
            </div>
        )
    }

    renderContent(link, mimeType) {
        if (!link) return <p style={{textAlign: 'center', marginTop: 40}}>⚠️ Нет ссылки на файл</p>

        const {fullWidth, fileUrl} = this.state

        const containerStyle = {
            width: fullWidth ? '100%' : '90%',
            maxWidth: fullWidth ? '100%' : '900px',
            height: fullWidth ? '100vh' : '85vh',
            backgroundColor: '#f7f7f7',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            overflow: 'hidden',
            position: 'relative',
            margin: '0 auto',
            borderRadius: fullWidth ? 0 : 12,
            boxShadow: fullWidth ? 'none' : '0 8px 20px rgba(0,0,0,0.15)',
            transition: 'all 0.3s ease',
        }

        if (mimeType === 'application/pdf' || mimeType.startsWith('application/')) {
            if (!fileUrl) return null
            if (/Mobi|Android|iPhone|iPad/i.test(navigator.userAgent)) {
                window.location.href = fileUrl
            }
            return (
                <div style={{position: 'relative'}}>
                    <button
                        className={'pdf-viewer-btn'}
                        onClick={this.toggleFullWidth}
                        style={{right: fullWidth ? 200 : 50}}
                        title={fullWidth ? "Свернуть" : "Развернуть"}
                    >
                        <i className={`fa ${fullWidth ? 'fa-compress' : 'fa-expand'}`}/>
                    </button>
                    <button
                        className={'pdf-viewer-btn'}
                        onClick={() => window.location.replace(link)}
                        style={{right: fullWidth ? 160 : 10}}
                        title={"Открыть на Google диске"}
                    >
                        <i className="fa fa-external-link-alt"/>
                    </button>
                    <div id="div-iframe" style={containerStyle}>
                        <iframe
                            src={fileUrl}
                            style={{
                                width: '100%',
                                height: '100%',
                                border: 'none',
                                borderRadius: fullWidth ? 0 : 12,
                                boxShadow: fullWidth ? 'none' : '0 8px 20px rgba(0,0,0,0.15)',
                                backgroundColor: '#fff'
                            }}
                            title="PDF Viewer"
                        />
                    </div>
                </div>
            )
        }

        return null
    }

    render() {
        const params = new URLSearchParams(window.location.search)
        const link = params.get('link')
        const mimeType = params.get('mime-type')

        return (
            <div style={{position: 'relative'}}>
                {this.state.loading && this.renderLoader()}
                {this.renderContent(link, mimeType)}
            </div>
        )
    }
}
